<template>
  <div class="container-fluid">
    <b-card class="mt-3 mb-1">
      <b-card-header class="p-0">
        <b-card-title class="card-title-doorder my-1"
          >Retailer Profile: {{ retailer.name }}</b-card-title
        >
      </b-card-header>
    </b-card>
    <b-form novalidate @submit.stop="onSubmit" ref="retailerEditProfileForm">
      <input type="hidden" name="client" v-model="client_name" />
      <b-card no-body class="card-transparent-background mt-0">
        <b-card-body class="p-0">
          <b-tabs
            pills
            class="doorderTabs"
            content-class="mt-3"
            align="center"
            v-model="tabIndex"
          >
            <b-tab
              title="General Details"
              title-link-class=" btn-tab btn-doorder-tab"
            >
              <CompanyDetails
                type="edit"
                status="current"
                :company_name.sync="retailer.name"
                :invalid_company_name="invalid_company_name"
                :company_website.sync="retailer.company_website"
                :invalid_company_website="invalid_company_website"
                :business_type.sync="retailer.business_type"
                :invalid_business_type="invalid_business_type"
                :number_business_locations.sync="retailer.locations.length"
                :qr_scan_required.sync="retailer.qr_scan_required"
                :invoice_reference_number.sync="
                  retailer.invoice_reference_number
                "
                :invalid_invoice_reference_number="
                  invalid_invoice_reference_number
                " />
              <ContactDetails
                type="edit"
                :locations="retailer.locations"
                :contacts.sync="retailer.contacts"
                :contacts_locations="contacts_locations"
                class="mt-5"
            /></b-tab>
            <b-tab
              title="Locations"
              title-link-class=" btn-tab btn-doorder-tab"
            >
              <LocationDetails type="edit" :locations.sync="retailer.locations"
            /></b-tab>
            <b-tab
              title="Shopify Details"
              title-link-class=" btn-tab btn-doorder-tab"
            >
              <ShopifyDetails
                type="edit"
                status="current"
                :shopify_store_domain.sync="retailer.shopify_store_domain"
                :shopify_app_api_key.sync="retailer.shopify_app_api_key"
                :shopify_app_password.sync="retailer.shopify_app_password"
                :shopify_app_secret.sync="retailer.shopify_app_secret"
            /></b-tab>
            <b-tab
              title="Payment Details"
              title-link-class=" btn-tab btn-doorder-tab"
            >
              <PaymentDetailsIBAN
                type="edit"
                status="current"
                :add_payment.sync="add_payment"
                :payment_type.sync="payment_type"
                :stripe_token.sync="stripe_token"
              />
            </b-tab>
            <b-tab
              title="Sub-Account"
              title-link-class=" btn-tab btn-doorder-tab"
            >
            </b-tab>
            <b-tab title="Users" title-link-class=" btn-tab btn-doorder-tab">
            </b-tab>
          </b-tabs>
        </b-card-body>
      </b-card>
      <b-row class="justify-content-center">
        <b-col lg="3" md="3" sm="4" class="text-center">
          <b-button
            v-if="!is_loading"
            type="submit"
            variant="doorder-primary"
            class="btn-bumblebee btn-doorder w-100 mb-1"
            >Save</b-button
          >
          <b-button
            type="button"
            disabled
            variant="doorder-primary"
            class="btn-bumblebee btn-doorder w-100 mb-1"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading</b-button
          >
        </b-col>

        <b-col lg="3" md="3" sm="4" class="text-center">
          <b-button
            type="button"
            variant="doorder-danger-outline"
            class="btn-bumblebee btn-doorder w-100 mb-1"
            v-b-modal.delete-retailer-modal-doorder
            >Delete</b-button
          >
        </b-col>
      </b-row>
    </b-form>
    <!-- delete modal -->
    <DeleteRetailerModel :retailer_id="retailer.id" />
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import moment from "moment";

import CompanyDetails from "./profile_details_components/CompanyDetails.vue";
import LocationDetails from "./profile_details_components/LocationDetails.vue";
import ContactDetails from "./profile_details_components/ContactDetails.vue";
import PaymentDetailsIBAN from "./profile_details_components/PaymentDetailsIBAN";
import ShopifyDetails from "./profile_details_components/ShopifyDetails.vue";
import DeleteRetailerModel from "./DeleteRetailerModel.vue";

export default {
  name: "DoorderRetailerEdit",
  components: {
    CompanyDetails,
    LocationDetails,
    ContactDetails,
    PaymentDetailsIBAN,
    ShopifyDetails,
    DeleteRetailerModel,
  },
  data() {
    return {
      tabIndex: 0,

      client_name: "DOORDER",
      retailer: null,
      is_loading: false,

      add_payment: false,
      payment_type: null,
      stripe_token: null,

      contacts_locations: [],

      invalid_company_name: false,
      invalid_company_website: false,
      invalid_business_type: false,
      invalid_invoice_reference_number: false,
      invalid_locations: false,
      invalid_contacts: false,
    };
  },
  mounted() {
    this.getRetailerViewData();
  },
  updated() {
    // console.log("in updated");
    // console.log(this.retailer);
  },
  watch: {
    "retailer.locations"(newval, oldval) {
      // console.log("watch retailer");
      // console.log(newval);
      // console.log(oldval);
      this.contacts_locations = [];
      for (var i = 0; i < newval.length; i++) {
        this.contacts_locations.push("Location " + (i + 1));
      }
      // this.retailer = Object.assign({}, this.retailer);
    },
    // retailer: {
    //   handler(newValue, oldValue) {
    //     // Note: `newValue` will be equal to `oldValue` here
    //     // on nested mutations as long as the object itself
    //     // hasn't been replaced.
    //     console.log("watch retailer");
    //     console.log(newValue);
    //     console.log(oldValue);
    //     this.contacts_locations = [];
    //     for (var i = 0; i < newValue.locations.length; i++) {
    //       this.contacts_locations.push("Location " + (i + 1));
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    getRetailerViewData() {
      axios
        .get("/retailer/profile/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.retailer = response.data.retailer;
          this.retailer.qr_scan_required =
            this.retailer.qr_scan_required == 1 ? true : false;

          // for (let i = 0; i < this.retailer.locations.length; i++) {
          //   this.retailer.locations[i].invalid_country = false;
          //   this.retailer.locations[i].invalid_county = false;
          //   this.retailer.locations[i].invalid_post_code = false;
          //   this.retailer.locations[i].invalid_address = false;
          //   this.retailer.locations[i].invalid_business_hours = false;
          // }
          // this.retailer = Object.assign({}, this.retailer);

          // this.events = response.data;
          //   this.setEventData(response.data);
        });
    },
    onSubmit(e) {
      // alert("submit");
      e.preventDefault();

      this.is_loading = true;

      console.log("submit edit retailer");
      console.log(this.retailer);
      this.checkValidation();
    },
    checkValidation() {
      console.log("check validation");
      // validate company details
      if (this.retailer.name == null || this.retailer.name == "") {
        this.invalid_company_name = true;
      } else {
        this.invalid_company_name = false;
      }
      if (
        this.retailer.company_website == null ||
        this.retailer.company_website == ""
      ) {
        this.invalid_company_website = true;
      } else {
        this.invalid_company_website = false;
      }
      if (
        this.retailer.business_type == null ||
        this.retailer.business_type == ""
      ) {
        this.invalid_business_type = true;
      } else {
        this.invalid_business_type = false;
      }
      // if (
      //   this.retailer.invoice_reference_number == null ||
      //   this.retailer.invoice_reference_number == ""
      // ) {
      //   this.invalid_invoice_reference_number = true;
      // } else {
      //   this.invalid_invoice_reference_number = false;
      // }

      // validate locations
      this.invalid_locations = false;
      for (var i = 0; i < this.retailer.locations.length; i++) {
        let location = this.retailer.locations[i];
        // if (location.country == null || location.country == "") {
        //   this.retailer.locations[i].invalid_country = true;
        //   this.invalid_locations = true;
        // } else {
        //   this.retailer.locations[i].invalid_country = false;
        // }
        // if (location.county == null || location.county == "") {
        //   this.retailer.locations[i].invalid_county = true;
        //   this.invalid_locations = true;
        // } else {
        //   this.retailer.locations[i].invalid_county = false;
        // }

        if (location.post_code == null || location.post_code == "") {
          this.retailer.locations[i].invalid_post_code = true;
          this.invalid_locations = true;
        } else {
          this.retailer.locations[i].invalid_post_code = false;
        }

        if (location.address == null || location.address == "") {
          this.retailer.locations[i].invalid_address = true;
          this.invalid_locations = true;
        } else {
          this.retailer.locations[i].invalid_address = false;
        }
        if (location.business_hours == null || location.business_hours == "") {
          this.retailer.locations[i].invalid_business_hours = true;
          this.invalid_locations = true;
        } else {
          this.retailer.locations[i].invalid_business_hours = false;
        }

        let temp = this.retailer.locations[i].address 
        this.retailer.locations[i].address = null
        this.retailer.locations[i].address = temp
      }

      setTimeout(function () {
        this.retailer = Object.assign({}, this.retailer);
      }, 2000);

      //validate contacts
      this.invalid_contacts = false;
      for (let i = 0; i < this.retailer.contacts.length; i++) {
        let contact = this.retailer.contacts[i];
        console.log(contact);
        console.log(contact.location);
        if (contact.phone == null || contact.phone == "") {
          this.retailer.contacts[i].invalid_phone_number = true;
          this.invalid_contacts = true;
        } else {
          this.retailer.contacts[i].invalid_phone_number = false;
        }
        if (contact.location == null || contact.location == "") {
          this.retailer.contacts[i].invalid_location = true;
          this.invalid_contacts = true;
        } else {
          this.retailer.contacts[i].invalid_location = false;
        }
        if (contact.name == null || contact.name == "") {
          this.retailer.contacts[i].invalid_name = true;
          this.invalid_contacts = true;
        } else {
          this.retailer.contacts[i].invalid_name = false;
        }
        if (contact.email == null || contact.email == "") {
          this.retailer.contacts[i].invalid_email = true;
          this.invalid_contacts = true;
        } else {
          this.retailer.contacts[i].invalid_email = false;
        }
      }
      this.retailer = Object.assign({}, this.retailer);

      if (
        this.invalid_company_name ||
        this.invalid_company_website ||
        this.invalid_business_type ||
        this.invalid_invoice_reference_number ||
        this.invalid_contacts
      ) {
        this.is_loading = false;
        this.tabIndex = 0;
        this.retailer = Object.assign({}, this.retailer);
      } else if (this.invalid_locations) {
        this.is_loading = false;
        this.tabIndex = 1;
        this.retailer = Object.assign({}, this.retailer);
      } else {
        this.sendEditRetailerDataRequest();
      }
    },
    sendEditRetailerDataRequest() {
      console.log(
        "in send edit retailer request ",
        this.client_name,
        this.retailer.id
      );
      console.log("company details");
      console.log(
        this.retailer.id,
        this.retailer.name,
        this.retailer.company_name,
        this.retailer.company_website,
        this.retailer.business_type,
        this.retailer.number_business_locations,
        this.retailer.locations_count,
        this.retailer.invoice_reference_number,
        this.retailer.qr_scan_required
      );
      console.log("contacts details");
      for (var i = 0; i < this.retailer.contacts.length; i++) {
        console.log(this.retailer.contacts[i]);
      }
      console.log("locations details");
      for (var i = 0; i < this.retailer.locations.length; i++) {
        console.log(this.retailer.locations[i]);
      }

      console.log("shopify detailes");
      console.log(this.retailer.shopify_store_domain);
      console.log(this.retailer.shopify_app_api_key);
      console.log(this.retailer.shopify_app_password);
      console.log(this.retailer.shopify_app_secret);

      let requestData = {
        client: this.client_name,
        id: this.retailer.id,
        company_name: this.retailer.name,
        company_website: this.retailer.company_website,
        business_type: this.retailer.business_type,
        number_business_locations: this.retailer.locations_count,
        invoice_reference_number: this.retailer.invoice_reference_number,
        qr_scan_required: this.retailer.qr_scan_required,
        contacts: this.retailer.contacts,
        locations: this.retailer.locations,
        shopify_store_domain: this.retailer.shopify_store_domain,
        shopify_app_api_key: this.retailer.shopify_app_api_key,
        shopify_app_password: this.retailer.shopify_app_password,
        shopify_app_secret: this.retailer.shopify_app_secret,
        // stripe_token: this.stripe_token,
      };
      console.log(requestData);
      axios
        .post("retailer/update", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: response.data.message,
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$router.go();
          // this.$refs.retailerRegisterForm.reset();
          // this.locations = [
          //   {
          //     address: "",
          //     post_code: "",
          //     latitude: "",
          //     longitude: "",
          //     country: "",
          //     county: "",
          //     business_hours: "",
          //     business_hours_json: "",
          //   },
          // ];
          // this.contacts = [{ name: "", phone: "", email: "", location: null }];
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/retailers/EditRetailer.vue